import { ChangeDetectionStrategy, Component } from '@angular/core';

import { DsFormlyFieldType } from '@app/forms/formly/types/ds-formly-field';

@Component({
  selector: 'cc-cvv-field',
  templateUrl: './cc-cvv-field.component.html',
  styleUrls: ['./cc-cvv-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CcCvvFieldComponent extends DsFormlyFieldType {}
